import { AxiosStatic } from "axios";

import { CustomerDetailsModel } from "./models";

export class CustomerDetailsApi {
    private apiUrl = "/api/customer";
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async load(): Promise<CustomerDetailsModel> {
        const response = await this.axios.get<CustomerDetailsModel>(this.apiUrl);
        return response.data;
    }

    public async isEmailDomainSharedAcrossMultipleCustomers(emailAddress: string): Promise<boolean> {
        const response = await this.axios.get<boolean>(`${this.apiUrl}/isEmailDomainSharedAcrossMultipleCustomers/${emailAddress}`);
        return response.data;
    }
}
